// extracted by mini-css-extract-plugin
module.exports = {"loading":"c7","fullscreenWrapper":"c8","centeredSpinner":"c9","rotation":"c-","withoutLayer":"c_"};